<template>
  <svg :width="width" :height="height"
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      viewBox="0 0 300 300"
      id="svg2"
      version="1.1"
      inkscape:version="0.91 r13725"
      sodipodi:docname="3dprinteros_icon_spaceclaim.svg">
    <metadata
        id="metadata30">
      <rdf:RDF>
        <cc:Work
            rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
              rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <defs
        id="defs28">
      <pattern
          y="0"
          x="0"
          height="6"
          width="6"
          patternUnits="userSpaceOnUse"
          id="EMFhbasepattern" />
    </defs>
    <sodipodi:namedview
        pagecolor="#ffffff"
        bordercolor="#666666"
        borderopacity="1"
        objecttolerance="10"
        gridtolerance="10"
        guidetolerance="10"
        inkscape:pageopacity="0"
        inkscape:pageshadow="2"
        inkscape:window-width="1872"
        inkscape:window-height="1083"
        id="namedview26"
        showgrid="false"
        inkscape:zoom="0.78666667"
        inkscape:cx="-8.2627119"
        inkscape:cy="200.84746"
        inkscape:window-x="0"
        inkscape:window-y="0"
        inkscape:window-maximized="0"
        inkscape:current-layer="svg2" />
    <path
        d="m 150.00022,-8.10489e-6 c 82.84289,0 149.99983,67.15728910489 149.99983,150.00016810489 0,82.84287 -67.15694,149.99984 -149.99983,149.99984 -82.842882,0 -150.00017737106,-67.15694 -150.00017737106,-149.99984 0,-82.842849 67.15729537106,-150.00016810489 150.00017737106,-150.00016810489"
        style="fill:#f5f5f5;fill-rule:evenodd"
        id="path8"
        inkscape:connector-curvature="0" />
    <path
        inkscape:connector-curvature="0"
        id="path4194"
        d="m 109.39857,97.536851 81.20295,0 c 6.4493,0 11.72601,5.290409 11.72601,11.756439 l 0,81.41341 c 0,6.4659 -5.27671,11.75644 -11.72601,11.75644 l -81.20295,0 c -6.44929,0 -11.72601,-5.29054 -11.72601,-11.75644 l 0,-81.41341 c 0,-6.46603 5.27672,-11.756439 11.72601,-11.756439 z"
        style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none" />
    <path
        inkscape:connector-curvature="0"
        id="path4196"
        d="m 109.44749,96.214321 25.99265,0 c 0.19541,0 0.39083,0.098 0.58625,0.19591 l 45.53632,23.806649 c 0.48854,0.19601 0.68406,0.78392 0.68406,1.27363 l -3.90868,47.4178 17.9799,-54.66751 c -5.96074,-1.76346 -31.85568,-9.5031 -51.59447,-15.479269 -0.68398,-0.19602 -1.07489,-0.88174 -0.8795,-1.56753 0.19543,-0.58782 0.68407,-0.97971 1.27032,-0.97971 l 0,0 45.43831,0 c 3.61552,0 6.9379,1.46956 9.2831,3.918809 l 0,0 0,0 c 2.34519,2.35127 3.81095,5.58428 3.81095,9.20919 l 0,81.41342 c 0,3.52696 -1.46576,6.85781 -3.81095,9.20912 l 0,0 0,0 c -2.44293,2.35131 -5.66758,3.82087 -9.2831,3.82087 l -81.10519,0 c -3.61553,0 -6.84018,-1.46956 -9.28312,-3.82087 l 0,0 0,0 c -2.345201,-2.35131 -3.810952,-5.68216 -3.810952,-9.20912 l 0,-18.51655 c 0,-0.49001 0.390833,-0.97965 0.879489,-1.17555 l 17.784513,-8.6215 c 0.48855,-0.1956 1.07487,-0.0978 1.46574,0.19562 l 35.56914,31.64454 -32.83304,-47.22181 -0.29313,0.196 c -3.02924,2.25329 -11.13976,8.22948 -20.520589,15.18529 -0.586262,0.49002 -1.368045,0.2944 -1.758923,-0.19562 -0.195421,-0.29342 -0.293126,-0.49002 -0.293126,-0.78344 l 0,0 0,-12.44232 c 0,-0.58773 0.488556,-1.17564 1.172597,-1.27364 l 21.790931,-3.82061 13.8757,-2.44926 c 0.58626,-0.098 1.07489,0.196 1.36805,0.68563 l 25.69979,39.97201 -18.85936,-54.37364 -0.39083,0.098 c -5.27698,2.05729 -23.84312,9.20913 -42.897946,16.45892 -0.683977,0.19601 -1.368027,-0.098 -1.66119,-0.78363 -0.09781,-0.19601 -0.09781,-0.29401 -0.09781,-0.48993 l 0,0 0,-24.98232 c 0,-0.19591 0,-0.39182 0.09781,-0.48982 -0.09781,-0.098 -0.09781,-0.29391 -0.09781,-0.39182 l 0,0 0,-7.83764 c 0,-3.62491 1.465751,-6.85792 3.810956,-9.20919 l 0,0 0.0978,-0.098 c 2.34522,-2.351279 5.56986,-3.820849 9.1854,-3.820849 z m 32.73538,28.901119 c 0.0978,0 0.19541,0 0.29312,0 l 16.02556,2.93924 c 0.58627,0.098 0.9772,0.58772 1.07489,1.07765 l 0,0 10.06483,46.53583 1.36803,-57.60649 c -7.42648,0.098 -43.77741,0.29391 -64.20018,0.39192 l 35.08057,6.56389 c 0.0978,0 0.19542,0 0.29313,0.098 z"
        style="fill:#cec6c3;fill-opacity:1;fill-rule:evenodd;stroke:none" />
    <path
        inkscape:connector-curvature="0"
        id="path4198"
        d="m 109.39789,97.536851 81.20432,0 c 6.44821,0 11.72602,5.290409 11.72602,11.756439 l 0,81.41341 c 0,6.4659 -5.27781,11.75644 -11.72602,11.75644 l -81.20432,0 c -6.4482,0 -11.726026,-5.29054 -11.726026,-11.75644 l 0,-81.41341 c 0,-6.46603 5.277826,-11.756439 11.726026,-11.756439 z"
        style="fill:none;stroke:#584b4c;stroke-width:5.17900658px;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
  </svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 300
      },
      height: {
        type: [Number, String],
        default: 300
      }
    }
  }
</script>